import { months } from '@constants/date';
import { DropdownOption } from 'types/dropdown';

const allMonthEntries = Object.entries(months).map(([index, monthInfo]) => ({
  month: monthInfo.name,
  index: Number(index)
}));

export const getDefaultDateRange = () => {
  const currentYear = new Date().getFullYear();
  return {
    minDate: new Date(currentYear - 100, 0, 1),
    maxDate: new Date(currentYear + 10, 11, 31)
  };
};

const isMonthInBounds = (
  index: number,
  year: number,
  minDate: Date,
  maxDate: Date
): boolean => {
  if (year === minDate.getFullYear() && index < minDate.getMonth()) {
    return false;
  }
  if (year === maxDate.getFullYear() && index > maxDate.getMonth()) {
    return false;
  }
  return true;
};

export const getBoundedMonthOptions = (
  year: number,
  minDate: Date,
  maxDate: Date
): DropdownOption[] =>
  allMonthEntries
    .filter(({ index }) => isMonthInBounds(index, year, minDate, maxDate))
    .map(({ month, index }) => ({
      id: String(index),
      label: month,
      value: String(index)
    }));

export const getBoundedYearOptions = (
  minDate: Date,
  maxDate: Date
): DropdownOption[] => {
  const options: DropdownOption[] = [];
  for (
    let year = maxDate.getFullYear();
    year >= minDate.getFullYear();
    year -= 1
  ) {
    options.push({
      id: String(year),
      label: String(year),
      value: String(year)
    });
  }
  return options;
};

export const clampMonthToBounds = (
  month: string,
  year: string,
  minDate: Date,
  maxDate: Date
): string => {
  const options = getBoundedMonthOptions(Number(year), minDate, maxDate);
  if (options.some((option) => option.value === month)) return month;
  const later = options.find((option) => Number(option.value) > Number(month));
  return later?.value ?? options[options.length - 1]?.value ?? month;
};
